import Link from 'next/link'
import Icon from 'ui/components/Icon'
import { Tooltip } from 'ui/components/tooltips/Tooltip'
import {
  Card,
  Info,
  Name,
  Position,
  AdditionalText,
  UserTooltipIcon,
} from './styled'
import { AvatarSpecial } from '../AvatarSpecial'
import {
  USER_CARD_SMALL_MODE,
  LINK_MODES,
  SERVICE_USER_TOOLTIP_TITLE,
  DEACTIVATED_USER_TOOLTIP_TITLE,
} from './constants'
import { getAdditionalText } from './helpers'

const { DEFAULT, MODAL, USER_LIST } = USER_CARD_SMALL_MODE

const UserCardSmall = ({
  mode = DEFAULT,
  as,
  href = null,
  handler,
  direction = 'horizontal',
  name = '',
  avatar,
  isApi,
  position = '',
  additionalText = '',
  style,
  isServiceUser = false,
  isActiveUser = true,
}) => {
  const isLinkMode = LINK_MODES.includes(mode) && href
  const isModalMode = mode === MODAL
  const isUserListMode = mode === USER_LIST

  const shouldShowDetails = !isUserListMode
  const shouldShowServiceUserTooltip = isUserListMode && isServiceUser
  const shouldShowDeactivatedUserTooltip = isUserListMode && !isActiveUser

  const preparedAdditionalText = getAdditionalText(additionalText, mode)

  const content = (
    <>
      <AvatarSpecial src={avatar} isApi={isApi} alt={name} />

      <Info>
        <Name>
          {name}

          {shouldShowServiceUserTooltip && (
            <Tooltip title={SERVICE_USER_TOOLTIP_TITLE} placement="top">
              <UserTooltipIcon>
                <Icon name="settings" size="16" />
              </UserTooltipIcon>
            </Tooltip>
          )}

          {shouldShowDeactivatedUserTooltip && (
            <Tooltip title={DEACTIVATED_USER_TOOLTIP_TITLE} placement="top">
              <UserTooltipIcon>
                <Icon name="deactivated" size="12" />
              </UserTooltipIcon>
            </Tooltip>
          )}
        </Name>

        {shouldShowDetails && position && <Position>{position}</Position>}

        {shouldShowDetails && preparedAdditionalText && (
          <AdditionalText>{preparedAdditionalText}</AdditionalText>
        )}
      </Info>
    </>
  )

  return (
    <Card style={style} direction={direction}>
      {isLinkMode && (
        <Link href={href} as={as}>
          <a onClick={handler} target="_blank" rel="noopener noreferrer">
            {content}
          </a>
        </Link>
      )}

      {isModalMode && <a onClick={handler}>{content}</a>}
    </Card>
  )
}

export default UserCardSmall
